// extracted by mini-css-extract-plugin
export default {"table-row":"table-row_table-row__8oEsN"};